__turbopack_context__.v({
  "autogrow": "TextArea-module__480bBa__autogrow",
  "container": "TextArea-module__480bBa__container",
  "container__fullWidth": "TextArea-module__480bBa__container__fullWidth",
  "field": "TextArea-module__480bBa__field",
  "label": "TextArea-module__480bBa__label",
  "message": "TextArea-module__480bBa__message",
  "message__error": "TextArea-module__480bBa__message__error",
  "textarea": "TextArea-module__480bBa__textarea",
  "textarea__error": "TextArea-module__480bBa__textarea__error",
  "textarea__fullWidth": "TextArea-module__480bBa__textarea__fullWidth",
});
